<template>
  <div>
    <v-dialog v-model="dialog" max-width="1024">
      <v-card :loading="loading">
        <v-alert v-if="error" type="error" class="mb-0">
          {{ error }}
        </v-alert>
        <v-row v-if="concessionRequest" class="mx-0">
          <v-col cols="12" md="8" class="pa-0">
            <v-tabs>
              <v-tab v-if="concessionRequest.documentFront">
                Frente do Documento
              </v-tab>
              <v-tab v-if="concessionRequest.documentBack">
                Verso do Documento
              </v-tab>
              <v-tab v-if="concessionRequest.user.selfie"> Selfie </v-tab>
              <v-btn @click="close" icon class="ml-auto mt-2">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-tab-item v-if="concessionRequest.documentFront">
                <ConcessionDocumentViewer
                  :src="concessionRequest.documentFront"
                  height="70vh"
                />
              </v-tab-item>
              <v-tab-item v-if="concessionRequest.documentBack">
                <ConcessionDocumentViewer
                  :src="concessionRequest.documentBack"
                  height="70vh"
                />
              </v-tab-item>
              <v-tab-item v-if="concessionRequest.user.selfie">
                <ConcessionDocumentViewer
                  :src="concessionRequest.user.selfie"
                  height="70vh"
                />
              </v-tab-item>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="4" class="d-flex flex-column pa-4">
            <div class="d-flex justify-center align-center gap-3">
              <div class="flex-grow-0">
                <v-img
                  :src="concessionRequest.user.selfie"
                  width="80"
                  height="100"
                  class="rounded-xl"
                />
              </div>
              <div class="flex-grow-1">
                <h6 class="mb-1">{{ concessionRequest.user.name }}</h6>
                <p class="text-body-2 mb-0">
                  {{ concessionRequest.user.document }}
                  <template v-if="concessionRequest.user.birthday">
                    •
                    {{ [concessionRequest.user.birthday] | dateDiff }}
                    •
                    {{ concessionRequest.user.birthday | date("DD/MM/YYYY") }}
                  </template>
                </p>
                <p class="text-body-2 mb-0">
                  {{ concessionRequest.user.email }}
                </p>
                <p class="text-body-2 mb-0">
                  {{ concessionRequest.user.phone }}
                </p>
              </div>
            </div>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Tipo de benefício
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ definitions.types[concessionRequest.type].name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Data da solicitação
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ concessionRequest.createdAt | date }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-spacer />
            <div class="pa-2">
              <v-divider class="mb-2" />
              <b>Resultado</b>
              <div class="d-flex flex-column gap-2">
                <v-switch
                  v-model="lifetime"
                  label="Vitalício"
                  class="mt-2 mb-2"
                  hide-details
                  dense
                />
                <div v-if="!lifetime">
                  <v-text-field
                    v-model="expiresAt"
                    label="Data de expiração"
                    type="date"
                    :disabled="lifetime"
                    outlined
                    hide-details
                    dense
                  />
                  <v-chip-group v-model="expiresAt" color="primary" :show-arrows="false">
                    <v-chip
                      v-for="reason in expiresHelpers"
                      :key="reason.value"
                      :value="reason.value"
                      class="mb-2"
                      x-small
                    >
                      {{ reason.label }}
                    </v-chip>
                  </v-chip-group>
                </div>
                <v-btn
                  block
                  color="primary"
                  @click="resolve(true)"
                  :disabled="!lifetime && !expiresAt"
                >
                  Aprovar
                </v-btn>
                <v-btn block color="error" @click="resolve(false)">
                  Reprovar
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <ConcessionResolveModal
      v-if="concessionRequest"
      :concessionRequest="concessionRequest"
      @success="success"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import definitions from "@/definitions/ConcessionRequest.json";
import CONCESSION_REQUEST from "@/services/admin/concessionRequest";
import ConcessionDocumentViewer from "./ConcessionDocumentViewer.vue";
import ConcessionResolveModal from "./ConcessionResolveModal.vue";
export default {
  name: "ConcessionRequestModal",
  components: {
    ConcessionDocumentViewer,
    ConcessionResolveModal,
  },
  data() {
    return {
      definitions,
      dialog: false,
      error: null,
      loading: false,
      lifetime: false,
      expiresAt: null,
      concessionRequest: null,
    };
  },
  methods: {
    open(id) {
      this.concessionRequest = null;
      this.loading = true;
      this.error = null;
      this.lifetime = false;
      this.expiresAt = null;
      this.dialog = true;
      this.getConcessionRequest(id);
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.error = null;
      this.lifetime = false;
      this.expiresAt = null;
      this.concessionRequest = null;
    },
    success() {
      this.$emit("refresh");
      this.$root.$emit("refreshConcessionRequest");
      this.close();
    },
    async getConcessionRequest(id) {
      try {
        this.loading = true;
        this.error = null;
        const response = await CONCESSION_REQUEST.getById(id);
        this.concessionRequest = response.concessionRequest;
      } catch (error) {
        this.error =
          error.message || "Erro ao buscar solicitação de meia entrada";
      } finally {
        this.loading = false;
      }
    },
    resolve(approved) {
      const data = {
        status: approved ? "APPROVED" : "REJECTED",
        expiresAt: this.lifetime ? null : this.expiresAt,
      };
      if (!approved) delete data.expiresAt;
      this.$emit("resolveConcessionRequest", data);
    },
  },
  computed: {
    ...mapGetters("company", ["selectedOrganization"]),
    expiresHelpers() {
      return [
        {
          label: "1 mês",
          value: moment().add(1, "month").format("YYYY-MM-DD"),
        },
        {
          label: "6 meses",
          value: moment().add(6, "month").format("YYYY-MM-DD"),
        },
        {
          label: "1 ano",
          value: moment().add(1, "year").format("YYYY-MM-DD"),
        },
        {
          label: "Fim do ano",
          value: moment().endOf("year").format("YYYY-MM-DD"),
        },
      ];
    },
  },
  mounted() {
    this.$parent.$on("viewConcessionRequest", this.open);
  },
};
</script>
